import { useRecordContext } from 'react-admin'
export const ResultCountryISO = () => {
	const record = useRecordContext()
	return <span>{record && record.CountryISO2 && record.CountryISO2 !== 'ZZ' ? `${record.CountryISO2}` : ''}</span>
}
export default ResultCountryISO
